// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__QVAcu","iconWrap":"styles_iconWrap__G5snl","text":"styles_text__34v_H"};
module.exports.__checksum = "f6af88c2c82e"